  const slider = document.getElementById('u-tested-slider');
  const handle = document.getElementById('u-tested-handle');
  const divider = document.getElementById('u-tested-divider');
  const beforeLabel = slider.querySelector('.u-tested-before-label');
  const afterLabel = slider.querySelector('.u-tested-after-label');
  const beforeImg = slider.querySelector('.u-tested-before-img');

  let active = false;

  function startDrag() {
    active = true;
  }
  function stopDrag() {
    active = false;
  }

  function moveHandle(e) {
    if (!active) return;

    let x = e.clientX || (e.touches && e.touches[0].clientX);
    const rect = slider.getBoundingClientRect();
    x = x - rect.left;

    if (x < 0) x = 0;
    if (x > rect.width) x = rect.width;

    const percent = (x / rect.width) * 100;

    handle.style.left = percent + '%';
    divider.style.left = percent + '%';

    beforeImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;

    const handleRect = handle.getBoundingClientRect();
    const beforeRect = beforeLabel.getBoundingClientRect();
    const afterRect = afterLabel.getBoundingClientRect();

    beforeLabel.style.opacity = handleRect.right > beforeRect.left && handleRect.left < beforeRect.right ? '0' : '1';
    afterLabel.style.opacity = handleRect.right > afterRect.left && handleRect.left < afterRect.right ? '0' : '1';
  }

  handle.addEventListener('mousedown', startDrag);
  window.addEventListener('mouseup', stopDrag);
  window.addEventListener('mousemove', moveHandle);

  handle.addEventListener('touchstart', startDrag);
  window.addEventListener('touchend', stopDrag);
  window.addEventListener('touchmove', moveHandle);